import React from 'react';
import Box from '@material-ui/core/Box';

import Typography from '@material-ui/core/Typography';
import CronTemplateIcon from '@material-ui/icons/Timer';

import { CreateButton } from 'react-admin';

const CronTemplateEmpty = ({ basePath, resource }) => (
  <Box textAlign="center" m={1}>
    <CronTemplateIcon style={{ fontSize: 140 }} />
    <Typography variant="h4" paragraph>
      No cron template available yet.
    </Typography>
    <Typography variant="body1">Do you want to add one?</Typography>
    <CreateButton className="primary" basePath={basePath} />
  </Box>
);

export default CronTemplateEmpty;
